import React from 'react';
import styles from './SingleProperty.module.css';
import Card from '../UI/card/Card';
import Button from '../UI/button/Button';
import MobileSingleReservationForm from '../mobileSingleReservationForm/MobileSingleReservationForm';
import classnames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
interface ISingleProperty {
  showMobileReservationInputFormFlag: boolean;
  checkMobileScreenFlag: boolean;
  singlePropertyHotelId: string;
  singlePropertyHotelName: string;
}

const SingleProperty = ({
  showMobileReservationInputFormFlag,
  checkMobileScreenFlag,
  singlePropertyHotelId,
  singlePropertyHotelName
}: ISingleProperty) => {
  const singlePropertyContainerClassnames = classnames(styles.singlePropertyContainer, {
    [styles.singlePropertyContainerDiv]: checkMobileScreenFlag && showMobileReservationInputFormFlag
  });
  const navigate = useNavigate();
  return (
    <section className={styles.singlePropertySection} aria-label="view user property">
      <Helmet>
        <title>{`${singlePropertyHotelName} | Booking.com`}</title>
      </Helmet>
      <Card className={singlePropertyContainerClassnames}>
        <section className={styles.singlePropertyContent}>
          <h1 style={{ fontSize: '20px' }}>
            <span style={{ fontWeight: '400' }}>Welcome,</span> {singlePropertyHotelName}.
          </h1>
          <p>
            During this period while we work to restore full access to our platform, please use this
            temporary interface to view your confirmed reservations
          </p>
          <br />
          <p>
            You can search by entering a reservation ID or a guest/booker name in the search field
            in the header, or click below to see all arrivals today.
          </p>
          <br />
          <Button
            className={styles.partnerListViewButton}
            type={'button'}
            onClick={() =>
              navigate(
                `/partner/hotel/reservation/${singlePropertyHotelId}/${singlePropertyHotelName}`
              )
            }>
            See today’s arrivals
          </Button>
        </section>
      </Card>
      {showMobileReservationInputFormFlag && checkMobileScreenFlag && (
        <MobileSingleReservationForm />
      )}
    </section>
  );
};

export default SingleProperty;
